document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.featured-collection-carousel');
  const toggleBtns = document.querySelectorAll('.toggle-btn');

  // Store original items for each carousel
  carousels.forEach(carousel => {
    const track = carousel.querySelector('.carousel-track');
    const items = Array.from(track.querySelectorAll('.carousel-item'));

    // Store the raw HTML of items to easily rebuild
    carousel.originalItems = items.map(item => ({
      element: item.cloneNode(true),
      tags: (item.getAttribute('data-tags') || '').split(',').map(t => t.trim())
    }));

    initCarousel(carousel);
  });

  // Initial Filter Run
  const activeBtn = document.querySelector('.toggle-btn.active');
  if (activeBtn) {
    const filter = activeBtn.getAttribute('data-filter');
    carousels.forEach(carousel => {
      filterCarousel(carousel, filter);
    });
  }

  // Toggle Logic
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      // Update active state
      toggleBtns.forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      const filter = this.getAttribute('data-filter');

      carousels.forEach(carousel => {
        filterCarousel(carousel, filter);
      });
    });
  });

  function filterCarousel(carousel, filter) {
    const track = carousel.querySelector('.carousel-track');

    // Filter items
    const filteredItems = carousel.originalItems.filter(item => {
      const hasItbmTag = item.tags.some(t => t.includes('itbm'));

      if (filter === 'shop') {
        // Show everything EXCEPT 'itbm'
        return !hasItbmTag;
      } else if (filter === 'itbm') {
        // Show ONLY 'itbm'
        return hasItbmTag;
      }
      return true;
    });

    // Rebuild DOM
    track.innerHTML = '';

    if (filteredItems.length === 0) {
      // Handle empty state if needed
      return;
    }

    const itemsPerPage = 10;
    let pageCount = 0;
    let currentPageDiv = null;

    filteredItems.forEach((item, index) => {
      if (index % itemsPerPage === 0) {
        currentPageDiv = document.createElement('div');
        currentPageDiv.classList.add('carousel-page');
        currentPageDiv.setAttribute('data-page', pageCount);
        track.appendChild(currentPageDiv);
        pageCount++;
      }

      // Clone again to ensure fresh reference
      currentPageDiv.appendChild(item.element.cloneNode(true));
    });

    // Re-initialize carousel
    if (carousel.isInitialized) {
      if (carousel.controller) {
        carousel.controller.reset();
      }
    } else {
      initCarousel(carousel);
    }
  }

  function initCarousel(carousel) {
    if (carousel.isInitialized) return;

    const track = carousel.querySelector('.carousel-track');
    const prevBtn = carousel.querySelector('.carousel-nav-dot.prev') || carousel.querySelector('.carousel-arrow.prev');
    const nextBtn = carousel.querySelector('.carousel-nav-dot.next') || carousel.querySelector('.carousel-arrow.next');
    const dotsContainer = carousel.querySelector('.carousel-dots');

    let currentPage = 0;
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;

    // Expose reset function
    carousel.controller = {
      reset: () => {
        currentPage = 0;
        const pages = carousel.querySelectorAll('.carousel-page');

        // Hide controls if 1 or 0 pages
        if (pages.length <= 1) {
          if (prevBtn) prevBtn.style.display = 'none';
          if (nextBtn) nextBtn.style.display = 'none';
          if (dotsContainer) dotsContainer.style.display = 'none';
        } else {
          if (prevBtn) prevBtn.style.display = 'flex';
          if (nextBtn) nextBtn.style.display = 'flex';
          if (dotsContainer) dotsContainer.style.display = 'flex';
          createDots();
        }

        if (pages.length > 0) {
          track.scrollTo({ left: 0 });
          updateButtons();
        }
      }
    };

    function createDots() {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (!dotsContainer) return;
      dotsContainer.innerHTML = ''; // Clear existing dots

      if (pages.length <= 1) return;

      pages.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.classList.add('carousel-dot');
        dot.setAttribute('aria-label', `Go to page ${index + 1}`);
        if (index === 0) dot.classList.add('active');

        dot.addEventListener('click', () => goToPage(index));
        dotsContainer.appendChild(dot);
      });
    }

    function goToPage(pageIndex) {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (pages.length === 0) return;

      currentPage = Math.max(0, Math.min(pageIndex, pages.length - 1));
      const scrollAmount = pages[currentPage].offsetLeft - track.offsetLeft;
      track.scrollTo({
        left: scrollAmount,
        behavior: 'smooth'
      });
      updateDots();
      updateButtons();
    }

    function updateDots() {
      if (!dotsContainer) return;
      const dots = dotsContainer.querySelectorAll('.carousel-dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentPage);
      });
    }

    function updateButtons() {
      const pages = carousel.querySelectorAll('.carousel-page');
      if (prevBtn) prevBtn.disabled = currentPage === 0;
      if (nextBtn) nextBtn.disabled = currentPage === pages.length - 1;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentPage > 0) goToPage(currentPage - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const pages = carousel.querySelectorAll('.carousel-page');
        if (currentPage < pages.length - 1) goToPage(currentPage + 1);
      });
    }

    track.addEventListener('scroll', () => {
      if (!isDragging) {
        const pages = carousel.querySelectorAll('.carousel-page');
        if (pages.length === 0) return;

        const scrollPosition = track.scrollLeft;
        const pageWidth = pages[0].offsetWidth;
        const newPage = Math.round(scrollPosition / pageWidth);

        if (newPage !== currentPage) {
          currentPage = newPage;
          updateDots();
          updateButtons();
        }
      }
    });

    // Touch events
    function touchStart(event) {
      isDragging = true;
      startPos = getPositionX(event);
      animationID = requestAnimationFrame(animation);
      track.classList.add('dragging');
    }

    function touchMove(event) {
      if (isDragging) {
        const currentPosition = getPositionX(event);
        currentTranslate = prevTranslate + currentPosition - startPos;
      }
    }

    function touchEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      track.classList.remove('dragging');

      const movedBy = currentTranslate - prevTranslate;
      const pages = carousel.querySelectorAll('.carousel-page');

      if (movedBy < -100 && currentPage < pages.length - 1) {
        currentPage += 1;
      }

      if (movedBy > 100 && currentPage > 0) {
        currentPage -= 1;
      }

      goToPage(currentPage);
      prevTranslate = currentTranslate;
    }

    function getPositionX(event) {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
    }

    function animation() {
      if (isDragging) requestAnimationFrame(animation);
    }

    track.addEventListener('mousedown', touchStart);
    track.addEventListener('touchstart', touchStart);
    track.addEventListener('mousemove', touchMove);
    track.addEventListener('touchmove', touchMove);
    track.addEventListener('mouseup', touchEnd);
    track.addEventListener('mouseleave', touchEnd);
    track.addEventListener('touchend', touchEnd);

    track.addEventListener('dragstart', (e) => e.preventDefault());

    window.addEventListener('resize', () => {
      goToPage(currentPage);
    });

    // Initial setup
    carousel.isInitialized = true;
    carousel.controller.reset();
  }
});
